// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__27MEN","productName":"Table_productName__34Ubm"};